import React, { FC, ReactElement } from "react";

import { Grid, Typography } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";

import { useAppSelector } from "../hooks/reduxhook";
import { getType } from "../redux/slices/typeSlice";
import { COLLECTION } from "../data/constants";

interface IUploadedFile {
  base64: string;
  name: string;
  filetype: string;
  size?: number;
}

interface IFileUpload {
  setFile: (files: FileList) => void;
  content: string;
  file?: IUploadedFile | null;
  files?: IUploadedFile[];
  fileTypes?: string[];
  multiple?: boolean;
}

const FileUpload: FC<IFileUpload> = ({
  setFile,
  content,
  file,
  files = [],
  fileTypes = [],
  multiple = false,
}): ReactElement => {
  const chatType = useAppSelector(getType);

  const handleChange = (selectedFiles: FileList | File) => {
    if (selectedFiles instanceof FileList) {
      setFile(selectedFiles);
      return;
    }

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(selectedFiles);
    setFile(dataTransfer.files);
  };

  const getSelectedFileText = () => {
    if (multiple && files.length > 0) {
      return `${files.length} file${files.length > 1 ? "s" : ""} selected`;
    }

    if (file) {
      return `File name: ${file.name}.${file.filetype}`;
    }

    return content;
  };

  return (
    <FileUploader
      multiple={multiple}
      handleChange={handleChange}
      name="file"
      types={chatType?.type === COLLECTION ? fileTypes : chatType?.uploadtypes}
      className="fileheight"
    >
      <Grid
        px={10}
        py={10}
        justifyContent="center"
        alignItems="center"
        container
        direction="column"
        sx={{
          background: "rgba(217,217,217,.37)",
          borderRadius: 2,
          cursor: "pointer",
          border: "1px dashed rgba(0,0,0,0.25)",
        }}
      >
        <Typography
          className="filename"
          textAlign="center"
          mt={2}
          color="primary"
        >
          {getSelectedFileText()}
        </Typography>

        {multiple && files.length > 0 && (
          <Typography
            textAlign="center"
            mt={1}
            color="text.secondary"
            fontSize="12px"
          >
            You can review and edit the index names below.
          </Typography>
        )}
      </Grid>
    </FileUploader>
  );
};

export default FileUpload;
